import { render, staticRenderFns } from "./MultiselectDesign.vue?vue&type=template&id=15bd70d0&"
import script from "./MultiselectDesign.vue?vue&type=script&lang=ts&"
export * from "./MultiselectDesign.vue?vue&type=script&lang=ts&"
import style0 from "./MultiselectDesign.vue?vue&type=style&index=0&id=15bd70d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports